import { Typography } from 'antd';

import { Box, styled } from '@mui/material';

import { varAlpha } from 'src/theme/styles';

export const TypographyStyled = styled(Typography.Title)`
  margin: 0 !important;
  &.ant-typography {
    border-color: ${({ theme }) => theme.vars.palette.primary.main};
  }
`;
export const ChapterWrapper = styled(Box)`
  padding: 10px 20px;
  background-color: ${({ theme }) => varAlpha(theme.vars.palette.primary.mainChannel, 0.17)};
  border-radius: 10px;
  width: 100%;
  display: flex;
  align-items: 'center';
  justify-content: 'space-bettwen';
  h5 {
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;
